<template>
  <v-container fluid class="pt-3">
    <v-layout row wrap class="control">
      <v-flex xs12 md12 class="text-xs-center">
        <div class="pb-3">
          <el-select
            v-model="form.shop_reference"
            placeholder="เลือกร้านค้า"
            :size="`small`"
            class="pr-2"
          >
            <el-option
              v-for="item in shopList"
              :key="item.shop_reference"
              :label="item.name"
              :value="item.shop_reference"
            ></el-option>
          </el-select>

          <el-date-picker
            size="small"
            v-model="daterange"
            type="daterange"
            value-format="yyyy-MM-dd"
            format="dd/MM/yyyy"
            range-separator="To"
            start-placeholder="Start date"
            end-placeholder="End date"
          ></el-date-picker>
          <el-button
            type="primary"
            :disabled="isLoading"
            class="ml-2"
            size="mini"
            @click="viewReport"
          >ค้นหา</el-button>
        </div>
      </v-flex>
    </v-layout>
    <el-card class="mt-3">
      <v-data-table :headers="headers" :items="items" :pagination.sync="pagination">
        <template v-slot:items="props">
          <td>{{ props.item.product_id }}</td>
          <td class="text-xs-left">{{ props.item.name }}</td>
          <td class="text-xs-left">{{ props.item.quantity | numFormat('0,0') }}</td>
          <td class="text-xs-right">
            <strong>฿ {{props.item.amount | numFormat('0,0')}}</strong>
          </td>
        </template>
      </v-data-table>
    </el-card>
  </v-container>
</template>

<script>
import Service from "../../services";

import moment from "moment";
export default {
  components: {},
  data() {
    return {
      isLoading: true,
      daterange: [moment().format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")],
      form: {
        shop_reference: ""
      },
      headers: [
        {
          text: "#",
          align: "left",
          sortable: false,
          value: "product_id"
        },
        { text: "ชื่อเมนู", value: "name" },
        { text: "จำนวนการขาย", value: "quantity" },
        { text: "ยอดขาย", align: "right", value: "amount" }
      ],

      pagination: { sortBy: "quantity", descending: true, rowsPerPage: -1 },
      shopList: [],
      items: []
    };
  },
  created() {
    Service.Shop.gets().then(res => {
      if (res.success) {
        this.shopList = res.data.map(item => {
          return {
            shop_reference: item.ref_no,
            name: item.name,
            status: item.status
          };
        });

        this.shopList = this.shopList.filter(function(item) {
          return item.status == "published";
        });

        this.isLoading = false;
      }
    });
  },
  methods: {
    viewReport() {
      let data = {
        begin: this.daterange[0],
        end: this.daterange[1],
        shop_reference: this.form.shop_reference
      };

      Service.Report.basket(data).then(res => {
        this.items = res.data;
      });
    }
  }
};
</script>